<template>
  <div>
    <el-drawer v-loading="loading" title="退货订单" :visible.sync="show" size="90%" :before-close="handleClose" destroy-on-close center :close-on-click-modal="false">
      <el-form ref="form" :disabled="type == '查看'|| isRejectTo" :model="form" :rules="rules" label-width="130px">
        <el-card header="基础信息">
          <el-row>
            <el-col :span="6">
              <el-form-item label="退货单号">
                <el-input v-model="form.sn" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="SAP销售单号">
                <el-input v-model="form.sapOrderSn" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="单据类型" prop="salesType">
                <el-select v-model="form.salesType" :disabled="isDisabled" placeholder="请选择" @change="changeSalesType">
                  <el-option
                    v-for="item in salesTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="销售单号" prop="salesOrderSn">
                <el-input v-model="form.salesOrderSn" readonly placeholder="请点击图标选择">
                  <el-button slot="append" icon="el-icon-search" @click="selectSalesOrderSn" />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="销售组织" prop="salesOrganizationId">
                <el-select v-model="form.salesOrganizationId" placeholder="选择销售单带出" :disabled="true" @change="
                    getOptionOrganization(form.salesOrganizationId)
                  ">
                  <el-option v-for="item in salesOrganizationOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="分销渠道" prop="channelOfDistributionId">
                <el-select v-model="form.channelOfDistributionId" :disabled="true" placeholder="选择销售单带出" @change="getProductTeamOption(form.channelOfDistributionId)">
                  <el-option v-for="item in channelDistributioOption" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品组" prop="productTeamId">
                <el-select v-model="form.productTeamId" :disabled="true" placeholder="选择销售单带出">
                  <el-option v-for="item in productTeamOption" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="业务类型" prop="businessTypeId">
                <el-select v-model="form.businessTypeId" :disabled="true" placeholder="选择销售单带出">
                  <el-option v-for="item in businessTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="售达方" prop="soldToPartyName">
                <el-input v-model="form.soldToPartyName" :disabled="true" placeholder="选择销售单带出">
                  <!-- <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="selectSoldToParty"
                    /> -->
                </el-input>
              </el-form-item>

            </el-col>
            <el-col :span="6">
              <el-form-item label="送达方" prop="deliverySideName">
                <el-input v-model="form.deliverySideName" :disabled="true" placeholder="选择销售单带出">
                  <!-- <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="selectDeliverySide"
                    /> -->
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据状态" prop="status">
                <el-input v-model="statusArr[form.status]" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="交货工厂" prop="factoryId">
                <el-select v-model="form.factoryId" :disabled="true" placeholder="选择销售单带出">
                  <el-option v-for="item in factoryOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="中间公司" prop="middleCompanyId">
                <el-input v-model="form.middleCompanyName" :disabled="true" placeholder="选择销售单带出">
                  <!-- <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="selectMiddleCompany"
                    /> -->
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人">
                <el-input v-model="form.createUser" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间">
                <el-input v-model="form.createTime" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退货原因" prop="orderGoodsCauseNo">
                <el-select v-model="form.orderGoodsCauseNo" placeholder="请选择">
                  <el-option v-for="item in orderReasonOptions" :key="item.code" :label="item.desc" :value="item.code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注">
                <el-input v-model="form.note" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据日期" prop="orderTime">
                <el-date-picker v-model="form.orderTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总金额(含税)">
                <el-input v-model="form.totalAmount" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card header="附件信息">
          <el-row>
            <FileUpload :file-type="['png', 'jpg', 'jpeg','doc','xls','pdf','xlsx','docx']" :value.sync="form.returnOrderAccessoryModels" :show-delect="form.status <= 1 || form.status==null" />
          </el-row>
        </el-card>
        <el-card header="订单明细">
          <el-tabs v-model="activePaneName">
            <el-tab-pane label="配件" name="mountings">
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="addMountingsLine()">配件明细</el-button>
                <!-- <el-button type="danger" @click="delectMountingsLine()">一键清空配件列表</el-button> -->
              </div>
              <el-table ref="mountingsTable" v-loading="showObj.mountings" height="400px" :data="form.mountingsList" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="交货数量" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="deliveryQty">
                      <el-input v-model="scope.row.deliveryQty" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="退货数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'mountingsList.' + scope.$index + '.qty'
                      " :rules="mountingsList.qty">
                      <el-input v-model="scope.row.qty" placeholder="请输入" min="0" type="number" @blur="sumLordDutyPrice(scope.row,scope.$index,'mountings')" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税单价" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'mountingsList.' + scope.$index + '.taxPrice'
                      " :rules="mountingsList.taxPrice">
                      <el-input v-model="scope.row.taxPrice" placeholder="请输入" min="0" type="number" @blur="sumLordDutyPrice(scope.row,scope.$index,'mountings')" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="是否采购退货" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="isPurchase">
                      <el-switch v-model="scope.row.isPurchase" active-text="是" inactive-text="否" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="终端含税价格" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="terminalPriceIncludingTax">
                      <el-input v-model="scope.row.terminalPriceIncludingTax" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="税率(%)" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="taxRatio">
                      <el-input v-model="scope.row.taxRatio" :disabled="true" placeholder="头部的销售组织带出" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="lordDutyPrice">
                      <el-input v-model="scope.row.lordDutyPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="终端含税金额" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="terminalTaxIncludedAmount">
                      <el-input v-model="scope.row.terminalTaxIncludedAmount" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="不含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="taxlessPrice">
                      <el-input v-model="scope.row.taxlessPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="批次号" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="batch">
                      <el-input v-model="scope.row.batch" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="OE" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="oeCode">
                      <el-input v-model="scope.row.oeCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车辆ID" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carId">
                      <el-input v-model="scope.row.carId" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carNo">
                      <el-input v-model="scope.row.carNo" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="品牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="brand">
                      <el-input v-model="scope.row.brand" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车系" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="series">
                      <el-input v-model="scope.row.series" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="年款" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="modelYear">
                      <el-input v-model="scope.row.modelYear" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="发动机型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="engineModel">
                      <el-input v-model="scope.row.engineModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="变速箱型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="transmissionModel">
                      <el-input v-model="scope.row.transmissionModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="排量" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="displacement">
                      <el-input v-model="scope.row.displacement" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="说明" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="120">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handleMountingsDelete(scope.$index)">删除</el-button>
                    <span v-if="scope.row.isPurchase" class="blueBtn" @click="setPurchase(scope.row,scope.$index)">采购信息</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <!-- <el-tab-pane label="废料" name="flotsam">
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="addFlotsamLine()">废料明细</el-button>
              </div>
              <el-table ref="flotsamTable" v-loading="showObj.flotsam" height="400px" :data="form.flotsamList" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="200">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="订单数量" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="orderNum">
                      <el-input v-model="scope.row.orderNum" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="交货数量" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="deliveryQty">
                      <el-input v-model="scope.row.deliveryQty" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="退货数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'flotsamList.' + scope.$index + '.qty'
                      "
                      :rules="flotsamList.qty"
                    >
                      <el-input v-model="scope.row.qty" placeholder="请输入" min="0" type="number" @blur="sumLordDutyPrice(scope.row,scope.$index,'mountings')" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税单价" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'flotsamList.' + scope.$index + '.taxPrice'
                      "
                      :rules="flotsamList.taxPrice"
                    >
                      <el-input v-model="scope.row.taxPrice" min="0" placeholder="请输入" type="number" @blur="sumLordDutyPrice(scope.row,scope.$index)" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="税率(%)" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="taxRatio">
                      <el-input v-model="scope.row.taxRatio" :disabled="true" placeholder="头部的销售组织带出" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="lordDutyPrice">
                      <el-input v-model="scope.row.lordDutyPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="不含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="taxlessPrice">
                      <el-input v-model="scope.row.taxlessPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="说明" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="handleFlotsamDelete(scope.$index)"
                    >删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane> -->
          </el-tabs>
        </el-card>
        <!-- v-if="form.status != 3" -->
        <el-card header="流程审批">
          <div v-if="form.status <= 1 || form.status==null">
            <el-row>
              <el-col :span="8">
                <el-form-item label="选择流程模板" prop="flowPathTemplateId">
                  <el-select v-model="form.flowPathTemplateId" placeholder="选择模板" @change="getFlowTempInfoList">
                    <el-option v-for="item in flowPathOptions" :key="item.id" :label="item.templateName" :value="item.id" />
                  </el-select>
                </el-form-item>

              </el-col>

            </el-row>
            <!-- <el-row>
              <el-col :span="6">
                <el-button
                  type="primary"
                  style="margin-bottom: 5px;"
                  @click="addNodePerson()"
                >新增审批人</el-button>
              </el-col>
            </el-row> -->

            <el-table v-if="form.flowPathNodePersonModels && form.flowPathNodePersonModels.length>0" ref="elTable" style="width:50%" :data="form.flowPathNodePersonModels" border>
              <el-table-column label="节点名称" align="left" show-overflow-tooltip width="150">
                <template slot-scope="scope">
                  <el-form-item prop="nodePersonName">
                    {{ scope.row.nodePersonName }}
                    <!-- <el-input
                      v-model="scope.row.companyName"
                      disabled
                    /> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="审批人" align="left" show-overflow-tooltip width="auto">
                <template slot-scope="scope">
                  <el-form-item :prop="
                      'flowPathNodePersonModels.' + scope.$index + '.nodePerson'
                    " :rules="flowPathNodePersonModels.nodePerson">
                    <el-input v-model="scope.row.nodePerson" readonly placeholder="请点击图标选择">
                      <el-button v-if="scope.row.variable" slot="append" icon="el-icon-search" @click="selectNodePerson(scope.$index)" />
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="deleteNodePerson(scope.$index)"
                  >删除</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <Flow ref="flow" :disabled="type == '查看' || form.status > 2" :custom-event="true" :flow-id="form.flowId" @flowLoad="flowLoad" @complete="onComplete" @refresh="flowRefresh" @rejectTo="flowRejectTo" />
        </el-card>
        <el-row style="padding: 10px 20px">
          <el-button :disabled="[3].includes(form.status)" :loading="loading" type="primary" @click="submitForm('form',false)">保存</el-button>
          <el-button v-if="form.id && (form.status == 1 || !form.status)" type="primary" @click="saveAndSubmit()">提交审核</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-row>
      </el-form>
    </el-drawer>
    <!-- 选择审批人 -->
    <el-dialog class="dialog" :title="'选择审批人'" :visible.sync="showObj.nodePerson" width="30%" :before-close="nodePersonClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.nodePerson.nodePerson" clearable placeholder="请输入审批人名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getNodePersonDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.nodePerson" border height="300" @selection-change="handleNodePersonSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="审批人" align="left" prop="nodePerson" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.nodePerson.total" :page.sync="pagination.nodePerson.current" :limit.sync="pagination.nodePerson.size" @pagination="getNodePersonDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nodePersonClose">取消</el-button>
        <el-button type="primary" @click="nodePersonConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 批量配件编码查询 -->
    <el-dialog class="dialog" :title="'批量编码查询(多个编码请用英文逗号分隔)'" :visible.sync="mountingsCodes" width="50%" :before-close="mountingsCodesClose" destroy-on-close center :close-on-click-modal="false">
      <el-input v-model="condition.mountings.productCodes" type="textarea" placeholder="多个编码请用英文逗号分隔" :rows="15" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="mountingsCodesClose">取消</el-button>
        <el-button type="primary" @click="mountingsCodesClose">确认</el-button>
      </span>
    </el-dialog>
    <!-- 售达方 -->
    <el-dialog class="dialog" :title="'选择售达方'" :visible.sync="showObj.soldToParty" width="60%" :before-close="soldToPartyClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.soldToParty.customerApplyName" clearable placeholder="请输入客户名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getSoldToPartyDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.soldToParty" border height="300" @selection-change="handleSoldToPartySelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="客户编码" align="left" prop="customerApplyNo" show-overflow-tooltip width="120" />
        <el-table-column label="客户名称" align="left" prop="customerApplyName" show-overflow-tooltip width="120" />
        <el-table-column label="客户类型" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.customerType == 1">固定</span>
            <span v-if="scope.row.customerType == 2">零星</span>
          </template>
        </el-table-column>
        <el-table-column label="经营类别" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.operateCategory | operateCategoryFilters }}
          </template>
        </el-table-column>
        <el-table-column label="联系人" align="left" prop="contacts" show-overflow-tooltip />
        <el-table-column label="联系方式" align="left" prop="contactsPhone" show-overflow-tooltip />
        <el-table-column label="详细地址" align="left" prop="address" show-overflow-tooltip />
        <el-table-column label="单据状态" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">制单</span>
            <span v-if="scope.row.status == 2">审核中</span>
            <span v-if="scope.row.status == 3">审核完成</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="left" prop="createUser" show-overflow-tooltip />
        <el-table-column label="创建时间" align="left" prop="createTime" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.soldToParty.total" :page.sync="pagination.soldToParty.current" :limit.sync="pagination.soldToParty.size" @pagination="getSoldToPartyDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="soldToPartyClose">取消</el-button>
        <el-button type="primary" @click="soldToPartyConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 送达方 -->
    <el-dialog class="dialog" :title="'选择送达方'" :visible.sync="showObj.deliverySide" width="60%" :before-close="deliverySideClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.deliverySide.customerApplyName" clearable placeholder="请输入客户名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getDeliverySideDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.deliverySide" border height="300" @selection-change="handleDeliverySideSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="客户编码" align="left" prop="customerApplyNo" show-overflow-tooltip width="120" />
        <el-table-column label="客户名称" align="left" prop="customerApplyName" show-overflow-tooltip width="120" />
        <el-table-column label="客户类型" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.customerType == 1">固定</span>
            <span v-if="scope.row.customerType == 2">零星</span>
          </template>
        </el-table-column>
        <el-table-column label="经营类别" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.operateCategory | operateCategoryFilters }}
          </template>
        </el-table-column>
        <el-table-column label="联系人" align="left" prop="contacts" show-overflow-tooltip />
        <el-table-column label="联系方式" align="left" prop="contactsPhone" show-overflow-tooltip />
        <el-table-column label="详细地址" align="left" prop="address" show-overflow-tooltip />
        <el-table-column label="单据状态" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">制单</span>
            <span v-if="scope.row.status == 2">审核中</span>
            <span v-if="scope.row.status == 3">审核完成</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="left" prop="createUser" show-overflow-tooltip />
        <el-table-column label="创建时间" align="left" prop="createTime" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.deliverySide.total" :page.sync="pagination.deliverySide.current" :limit.sync="pagination.deliverySide.size" @pagination="getDeliverySideDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deliverySideClose">取消</el-button>
        <el-button type="primary" @click="deliverySideConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 中间公司 -->
    <el-dialog class="dialog" :title="'选择中间公司'" :visible.sync="showObj.middleCompany" width="60%" :before-close="middleCompanyClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.middleCompany.customerApplyName" clearable placeholder="请输入销售客户名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getMiddleCompanyDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.middleCompany" border height="300" @selection-change="handleMiddleCompanySelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="销售组织编码" align="left" prop="salesOrganizationCode" show-overflow-tooltip width="120" />
        <el-table-column label="销售组织" align="left" prop="salesOrganizationName" show-overflow-tooltip width="150" />
        <el-table-column label="销售客户" align="left" prop="customerApplyName" show-overflow-tooltip width="150" />
        <el-table-column label="采购组织编码" align="left" prop="purchasingOrganizationCode" show-overflow-tooltip width="120" />
        <el-table-column label="采购组织" align="left" prop="purchasingOrganizationName" show-overflow-tooltip width="150" />
        <el-table-column label="采购供应商" align="left" prop="supplierName" show-overflow-tooltip width="150" />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.middleCompany.total" :page.sync="pagination.middleCompany.current" :limit.sync="pagination.middleCompany.size" @pagination="getMiddleCompanyDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="middleCompanyClose">取消</el-button>
        <el-button type="primary" @click="middleCompanyConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 销售单 -->
    <el-dialog class="dialog" :title="'选择销售单号'" :visible.sync="showObj.salesOrderSn" width="70%" :before-close="salesOrderSnClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.salesOrderSn.sn" clearable placeholder="请输入销售订单号" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.salesOrderSn.sapOrderSn" clearable placeholder="请输入SAP销售订单" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.salesOrderSn.soldToPartyName" clearable placeholder="请输入售达方" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.salesOrderSn.soldToPartyNumber" clearable placeholder="请输入售达方编码" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.salesOrderSn.deliverySideName" clearable placeholder="请输入送达方" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.salesOrderSn.deliverySideNumber" clearable placeholder="请输入送达方编码" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getSalesOrderSnDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.salesOrderSn" border height="300" @selection-change="handleSalesOrderSnSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="订单状态" align="left" prop="status" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">制单</span>
            <span v-if="scope.row.status == 2">审核中</span>
            <span v-if="scope.row.status == 3">审核完成</span>
          </template>
        </el-table-column>
        <el-table-column label="单据类型" align="left" prop="salesName" show-overflow-tooltip width="120" />
        <el-table-column label="销售订单号" align="left" prop="sn" show-overflow-tooltip width="130" />
        <el-table-column label="SAP销售单号" align="left" prop="sapOrderSn" width="130" show-overflow-tooltip />
        <el-table-column label="销售组织" align="left" prop="salesOrganizationName" show-overflow-tooltip width="150" />
        <el-table-column label="售达方编码" align="left" prop="soldToPartyNumber" show-overflow-tooltip />
        <el-table-column label="售达方" align="left" prop="soldToPartyName" show-overflow-tooltip />
        <el-table-column label="送达方编码" align="left" prop="deliverySideNumber" show-overflow-tooltip />
        <el-table-column label="送达方" align="left" prop="deliverySideName" show-overflow-tooltip />
        <el-table-column label="备注" align="left" prop="note" show-overflow-tooltip />
        <el-table-column label="创建人" align="left" prop="createUser" show-overflow-tooltip />
        <el-table-column label="创建时间" align="left" prop="createTime" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.salesOrderSn.total" :page.sync="pagination.salesOrderSn.current" :limit.sync="pagination.salesOrderSn.size" @pagination="getSalesOrderSnDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="salesOrderSnClose">取消</el-button>
        <el-button type="primary" @click="salesOrderSnConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 产品配料 -->
    <el-dialog class="dialog" title="产品配料" :visible.sync="showObj.mountings" width="70%" :before-close="mountingsClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.mountings.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <!-- <el-col :span="6">
          <el-input v-model="condition.mountings.productCode" clearable placeholder="请输入产品编码" />
        </el-col> -->
        <el-col :span="5">
          <el-input v-model="condition.mountings.productCodes" readonly placeholder="点击图标批量编码查询">
            <el-button slot="append" icon="el-icon-search" @click="selectMountingsCodes" />
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.oeCode" clearable placeholder="请输入OE" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.carNo" clearable placeholder="请输入车牌" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getMountings('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.mountings" :data="dialog.mountings" border height="300" @selection-change="handleMountingsChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />
        <el-table-column label="OE" align="left" prop="oeCode" show-overflow-tooltip />
        <el-table-column label="车辆ID" align="left" prop="carId" show-overflow-tooltip />
        <el-table-column label="车牌" align="left" prop="carNo" show-overflow-tooltip />
        <el-table-column label="品牌" align="left" prop="brand" show-overflow-tooltip />
        <el-table-column label="车系" align="left" prop="series" show-overflow-tooltip />
        <el-table-column label="年款" align="left" prop="modelYear" show-overflow-tooltip />
        <!-- <el-table-column
              label="燃料类型"
              align="left"
              prop="oeCode"
              show-overflow-tooltip
            /> -->
        <el-table-column label="发动机型号" align="left" prop="engineModel" show-overflow-tooltip />
        <el-table-column label="变速箱型号" align="left" prop="transmissionModel" show-overflow-tooltip />
        <el-table-column label="排量" align="left" prop="displacement" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.mountings.total" :page.sync="pagination.mountings.current" :limit.sync="pagination.mountings.size" @pagination="getMountings" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mountingsClose">取消</el-button>
        <el-button type="primary" @click="mountingsConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 产品废料 -->
    <el-dialog class="dialog" title="产品废料" :visible.sync="showObj.flotsam" width="60%" :before-close="flotsamClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.flotsam.productName" clearable placeholder="请输入产品名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getFlotsam('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.flotsam" :data="dialog.flotsam" border height="300" @selection-change="handleFlotsamChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.flotsam.total" :page.sync="pagination.flotsam.current" :limit.sync="pagination.flotsam.size" @pagination="getFlotsam" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="flotsamClose">取消</el-button>
        <el-button type="primary" @click="flotsamConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 配件-采购订单 -->
    <el-dialog class="dialog" title="采购订单信息" :visible.sync="showObj.purchase" width="50%" :before-close="purchaseClose" destroy-on-close center>
      <el-form ref="purchaseForm" :model="purchaseRow" :disabled="type == '查看'|| isRejectTo" :rules="purchaseRules" label-width="140px">
        <el-form-item label="sap采购退货订单号" prop="sapReturnPoNo">
          <el-input v-model="purchaseRow.sapReturnPoNo" :disabled="true" placeholder="自动生成" />
        </el-form-item>
        <el-form-item label="采购退货订单号" prop="sn">
          <el-input v-model="purchaseRow.sn" :disabled="true" placeholder="自动生成" />
        </el-form-item>
        <el-form-item label="采购销售订单号" prop="poNo">
          <el-input v-model="purchaseRow.poNo" :disabled="true" placeholder="自动生成" />
        </el-form-item>
        <el-form-item label="sap采购销售订单号" prop="sapPoNo">
          <el-input v-model="purchaseRow.sapPoNo" :disabled="true" placeholder="自动生成" />
        </el-form-item>
        <el-form-item label="供应商" prop="supplierId">
          <el-select v-model="purchaseRow.supplierId" :disabled="true">
            <el-option v-for="item in supplierOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="采购组织" prop="purchasingOrganizationId">
          <el-select v-model="purchaseRow.purchasingOrganizationId" :disabled="true">
            <el-option v-for="item in purchasingOrganizationOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="采购组" prop="purchaseBasicsId">
          <el-select v-model="purchaseRow.purchaseBasicsId" :disabled="true">
            <el-option v-for="item in purchaseBasicsOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="公司代码" prop="companyInfoNumber">
          <el-input v-model="purchaseRow.companyInfoNumber" readonly placeholder="请点击图标选择">
            <el-button slot="append" icon="el-icon-search" @click="setCompany" />
          </el-input>
        </el-form-item> -->
        <el-form-item label="单价" prop="unitPrice">
          <el-input v-model.number="purchaseRow.unitPrice" type="number" placeholder="请输入单价" clearable />
        </el-form-item>
        <el-form-item label="数量" prop="qty">
          <el-input v-model.number="purchaseRow.qty" type="number" placeholder="请输入数量" clearable />
        </el-form-item>
        <el-form-item label="进项税" prop="taxCode">
          <el-select v-model="purchaseRow.taxCode" :disabled="true">
            <el-option v-for="item in inputTaxOptions" :key="item.code" :label="item.name +'-'+item.code" :value="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="purchaseConfirm">确认</el-button>
          <el-button @click="purchaseClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>
import FileUpload from '@/components/FileUpload/index'
import { getPage as getSalesOrganization } from '@/api/crm/base/salesOrganization'
import { getPage as getDistributionChannels } from '@/api/crm/base/distributionChannels'
import { get as getProductTeam } from '@/api/crm/base/distributionChannels'
import { getPage as getFactory } from '@/api/crm/base/factory'
import { getPage as getTaxRate } from '@/api/crm/base/taxRate'
import { getBusinessType } from '@/api/crm/base/businessTypeDict'
import { getByGeneralManager } from '@/api/crm/base/audit'
import { getPage as getSupplierOptions } from '@/api/crm/base/supplier'
import { getPage as getPurchaseBasicsOptions } from '@/api/crm/base/purchase'
import { getPage as getPurchasingOrganization } from '@/api/crm/base/purchasingOrganization'
// import { getPage as getSalesOrder } from '@/api/crm/order/salesOrder'
import Pagination from '@/components/Pagination'
import Flow from '@/components/Flow'
import format from '@/utils/formatter'
import { getEnumItems } from '@/utils/enum'
import { getByPathTemplate, getFlowTempInfo } from '@/api/flow/processConfiguration'
import {
  get,
  saveOrUpdate,
  getByCustomerApply,
  getByMiddleCompany,
  getDetailedDataPopup,
  submit,
  getSalesOrder
} from '@/api/crm/order/returnGoodsOrder'
import { mergeObjectArrayWithoutDuplicates } from '@/utils/index'
export default {
  name: 'ReturnGoodsOrderEdit',
  components: {
    Pagination,
    FileUpload,
    Flow
  },
  filters: {
    operateCategoryFilters(e) {
      const arr = e.split(',')
      const arr1 = getEnumItems('Crm_Business_Category')
      const arr2 = []
      for (const item of arr) {
        for (const v of arr1) {
          if (v.code === item) {
            arr2.push(v.name)
          }
        }
      }
      console.log(arr2.join())
      return arr2.join()
    }
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false
      }
    },
    editId: Number
  },

  data() {
    return {
      companyOptions: [],
      salesOrganizationOptions: [],
      channelDistributioOption: [],
      productTeamOption: [],
      businessTypeOptions: [],
      factoryOptions: [],
      flowPathOptions: [],
      orderReasonOptions: getEnumItems('Crm_Order_Reason'),
      format: format,
      type: '',
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL,
      loading: false,
      form: {
        orderTime: format.formatDate(new Date(), 'yyyy-MM-dd'),
        salesReturnOrderLineVos: [],
        flotsamList: [],
        mountingsList: [],
        salesOrganizationId: null,
        channelOfDistributionId: null,
        productTeamId: null,
        salesType: null,
        soldToPartyName: null,
        salesOrderSn: null,
        businessTypeId: null,
        status: null,
        flowPathNodePersonModels: [],
        flowPathTemplateId: null,
        roleId: null,
        returnOrderAccessoryModels: []
      },
      statusArr: ['', '制单', '审核中', '审核完成'],
      flowPathNodePersonModels: {
        nodePerson: [
          { required: true, message: '审批人不能为空', trigger: 'change' }
        ]
      },
      mountingsList: {
        qty: [
          { required: true, message: '配件退货数量不能为空', trigger: 'blur' }
        ],
        taxPrice: [
          { required: true, message: '配件含税单价不能为空', trigger: 'blur' }
        ]
      },
      flotsamList: {
        qty: [
          { required: true, message: '废料退货数量不能为空', trigger: 'blur' }
        ],
        taxPrice: [
          { required: true, message: '废料含税单价不能为空', trigger: 'blur' }
        ]
      },
      rules: {
        // businessTypeId: [
        //   { required: true, message: '业务类型不能为空', trigger: 'change' }
        // ],
        salesType: [
          { required: true, message: '单据类型不能为空', trigger: 'change' }
        ],
        orderGoodsCauseNo: [
          { required: true, message: '退货原因不能为空', trigger: 'change' }
        ],
        salesOrderSn: [
          { required: true, message: '销售单号不能为空', trigger: 'change' }
        ],
        orderTime: [
          { required: true, message: '单据日期不能为空', trigger: 'change' }
        ]
      },
      purchaseRules: {
        purchasingOrganizationId: [
          { required: true, message: '采购组织不能为空', trigger: 'change' }
        ],
        unitPrice: [
          { required: true, message: '单价不能为空', trigger: 'blur' }
        ],
        qty: [
          { required: true, message: '数量不能为空', trigger: 'blur' }
        ],
        taxCode: [
          { required: true, message: '进项税不能为空', trigger: 'change' }
        ]
      },
      clientClassOptions: [],
      // salesTypeOptions: [{ value: 1, label: '借项订单' }, { value: 2, label: '贷项订单' }],
      activePaneName: 'mountings',
      showObj: {
        mountings: false,
        soldToParty: false,
        deliverySide: false,
        middleCompany: false,
        salesOrderSn: false,
        flotsam: false,
        nodePerson: false
      },
      loadingObj: {
        mountings: false,
        soldToParty: false,
        deliverySide: false,
        middleCompany: false,
        salesOrderSn: false,
        flotsam: false,
        nodePerson: false
      },
      mountingsCodes: false,
      // 分页
      pagination: {
        mountings: {
          total: 0,
          size: 20,
          current: 1
        },
        soldToParty: {
          total: 0,
          size: 20,
          current: 1
        },
        deliverySide: {
          total: 0,
          size: 20,
          current: 1
        },
        middleCompany: {
          total: 0,
          size: 20,
          current: 1
        },
        salesOrderSn: {
          total: 0,
          size: 20,
          current: 1
        },
        flotsam: {
          total: 0,
          size: 20,
          current: 1
        },
        nodePerson: {
          total: 0,
          size: 20,
          current: 1
        }
      },
      dialog: {
        mountings: [],
        soldToParty: [],
        deliverySide: [],
        middleCompany: [],
        salesOrderSn: [],
        flotsam: [],
        nodePerson: []
      },
      condition: {
        mountings: {},
        soldToParty: {},
        deliverySide: {},
        middleCompany: {},
        salesOrderSn: {},
        flotsam: {},
        nodePerson: {}
      },
      selection: {
        mountings: [],
        soldToParty: [],
        deliverySide: [],
        middleCompany: [],
        salesOrderSn: [],
        flotsam: {},
        nodePerson: {}
      },
      isDisabled: false,
      isRejectTo: false,
      purchaseRow: {
        poNo: null,
        sapPoNo: null,
        supplierId: null,
        purchasingOrganizationId: null,
        purchaseBasicsId: null,
        unitPrice: null,
        qty: null,
        taxCode: null
      },
      purchaseIndex: null,
      supplierOptions: [],
      purchaseBasicsOptions: [],
      inputTaxOptions: getEnumItems('InputTax'),
      purchasingOrganizationOptions: []
    }
  },
  watch: {
    show(show) {
      if (!show) {
        return
      }
      this.init()
      this.flowPathNodePersonModels.nodePerson[0].required = false
      if (this.editId == null) {
        this.form = this.$options.data.call(this).form
        return
      }
      this.getData()
    }
  },
  methods: {
    init() {
      getSalesOrganization({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.salesOrganizationOptions = records.map((item) => {
          return {
            label: item.salesOrganizationName,
            value: item.id
          }
        })
      })
      getFactory({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.factoryOptions = records.map((item) => {
          return {
            label: item.factoryNumber + '-' + item.factoryName,
            value: item.id
          }
        })
      })
      getByPathTemplate({ templateType: '退货订单' }, { current: 1, size: 100 }).then((res) => {
        const { records } = res.data
        this.flowPathOptions = records
        console.log(this.flowPathOptions)
      })
      getPurchasingOrganization({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.purchasingOrganizationOptions = records.map((item) => {
          return {
            label: item.purchasingOrganizationNumber + '-' + item.purchasingOrganizationName,
            value: item.id
          }
        })
      })
      getSupplierOptions({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.supplierOptions = records.map((item) => {
          return {
            label: item.supplierNo + '-' + item.supplierName,
            value: item.id
          }
        })
      })
      getPurchaseBasicsOptions({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.purchaseBasicsOptions = records.map((item) => {
          return {
            label: item.purchaseNo + '-' + item.purchaseName,
            value: item.id
          }
        })
      })
      console.log(this.form.orderTime)
    },
    // 基础数据
    changeSalesType(e) {
      const i = this.salesTypeOptions.findIndex((item) => item.code === e)
      if (i >= 0) {
        this.form.salesName = this.salesTypeOptions[i].name
      }
    },
    getOptionOrganization(id) {
      this.getChannelDistributioOption(id)
      this.getOptionOrganizationTaxRate(id)
      this.getBusinessTypeOption(id)
    },
    getBusinessTypeOption(id) {
      getBusinessType({ salesOrganizationId: id }, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.businessTypeOptions = records.map((item) => {
          return {
            label: item.salesOfficeCode + '-' + item.salesOfficeName,
            value: item.id
          }
        })
      })
    },
    async getOptionOrganizationTaxRate(id) {
      const { data } = await getTaxRate({ salesOrganizationId: id }, {
        total: 0,
        size: 20,
        current: 1
      })
      this.taxRatio = data.records[0].taxRatio
      this.calculation()
    },

    // 获取分销渠道
    async getChannelDistributioOption(id) {
      const { data } = await getDistributionChannels(
        { id },
        { current: 1, size: 1000 }
      )
      this.channelDistributioOption = data.records.map((item) => {
        return {
          label: item.channelDistributioName,
          value: item.id + ''
        }
      })
    },
    // 获取产品组
    async getProductTeamOption(id) {
      const { data } = await getProductTeam(id)
      this.productTeamOption = data.productTeamList.map((item) => {
        return {
          label: item.productTeamName,
          value: item.id + ''
        }
      })
    },
    // 售达方
    selectSoldToParty() {
      if (!this.form.salesOrganizationId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售组织'
        })
        return
      }
      this.showObj.soldToParty = true
      this.getSoldToPartyDialog()
    },
    async getSoldToPartyDialog() {
      this.loadingObj.soldToParty = true
      const data = {
        condition: {
          salesOrganizationId: this.form.salesOrganizationId,
          status: 3,
          customerApplyName: this.condition.soldToParty.customerApplyName
        },
        pagination: this.pagination.soldToParty
      }
      const reponse = await getByCustomerApply(data)
      const { current, total, size, records } = reponse.data
      this.dialog.soldToParty = records
      this.pagination.soldToParty.total = total
      this.pagination.soldToParty.current = current
      this.pagination.soldToParty.size = size
      this.loadingObj.soldToParty = false
    },

    handleSoldToPartySelectionChange(val) {
      this.selection.soldToParty = val
    },
    soldToPartyConfirm() {
      if (this.selection.soldToParty.length > 1) {
        this.$message.warning('只能选择一位售达方！')
      } else {
        this.showObj.soldToParty = false
        console.log(this.selection.soldToParty)
        this.form.soldToPartyId = this.selection.soldToParty[0].id
        this.form.soldToPartyName = this.selection.soldToParty[0].customerApplyName
      }
    },
    soldToPartyClose() {
      this.showObj.soldToParty = false
    },
    // 送达方
    selectDeliverySide() {
      if (!this.form.salesOrganizationId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售组织'
        })
        return
      }
      this.showObj.deliverySide = true
      this.getDeliverySideDialog()
    },
    async getDeliverySideDialog() {
      this.loadingObj.deliverySide = true
      const data = {
        condition: {
          salesOrganizationId: this.form.salesOrganizationId,
          status: 3,
          customerApplyName: this.condition.deliverySide.customerApplyName
        },
        pagination: this.pagination.deliverySide
      }
      const reponse = await getByCustomerApply(data)
      const { current, total, size, records } = reponse.data
      this.dialog.deliverySide = records
      this.pagination.deliverySide.total = total
      this.pagination.deliverySide.current = current
      this.pagination.deliverySide.size = size
      this.loadingObj.deliverySide = false
    },

    handleDeliverySideSelectionChange(val) {
      this.selection.deliverySide = val
    },
    deliverySideConfirm() {
      if (this.selection.deliverySide.length > 1) {
        this.$message.warning('只能选择一位送达方！')
      } else {
        this.showObj.deliverySide = false
        console.log(this.selection.deliverySide)
        this.form.deliverySideId = this.selection.deliverySide[0].id
        this.form.deliverySideName = this.selection.deliverySide[0].customerApplyName
      }
    },
    deliverySideClose() {
      this.showObj.deliverySide = false
    },
    // 中间公司
    selectMiddleCompany() {
      if (!this.form.salesOrganizationId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售组织'
        })
        return
      }
      this.showObj.middleCompany = true
      this.getMiddleCompanyDialog()
    },
    async getMiddleCompanyDialog() {
      this.loadingObj.middleCompany = true
      const data = {
        customerApplyName: this.condition.middleCompany.customerApplyName,
        salesOrganizationId: this.form.salesOrganizationId,
        pagination: this.pagination.middleCompany
      }
      const reponse = await getByMiddleCompany(data)
      const { current, total, size, records } = reponse.data
      this.dialog.middleCompany = records
      this.pagination.middleCompany.total = total
      this.pagination.middleCompany.current = current
      this.pagination.middleCompany.size = size
      this.loadingObj.middleCompany = false
    },

    handleMiddleCompanySelectionChange(val) {
      this.selection.middleCompany = val
    },
    middleCompanyConfirm() {
      if (this.selection.middleCompany.length > 1) {
        this.$message.warning('只能选择一个中间公司！')
      } else {
        this.showObj.middleCompany = false
        console.log(this.selection.middleCompany)
        this.form.middleCompanyId = this.selection.middleCompany[0].id
        this.form.middleCompanyName = this.selection.middleCompany[0].customerApplyName
      }
    },
    middleCompanyClose() {
      this.showObj.middleCompany = false
    },

    // 销售单
    selectSalesOrderSn() {
      this.showObj.salesOrderSn = true
      this.getSalesOrderSnDialog()
    },
    async getSalesOrderSnDialog() {
      this.loadingObj.salesOrderSn = true

      try {
        const reponse = await getSalesOrder(this.condition.salesOrderSn, this.pagination.salesOrderSn)
        const { current, total, size, records } = reponse.data
        this.dialog.salesOrderSn = records
        this.pagination.salesOrderSn.total = total
        this.pagination.salesOrderSn.current = current
        this.pagination.salesOrderSn.size = size
        this.loadingObj.salesOrderSn = false
      } catch (err) {
        this.loadingObj.salesOrderSn = false
      }
    },
    handleSalesOrderSnSelectionChange(val) {
      this.selection.salesOrderSn = val
    },
    salesOrderSnConfirm() {
      if (this.selection.salesOrderSn.length > 1) {
        this.$message.warning('只能选择一个销售单！')
      } else {
        this.showObj.salesOrderSn = false
        console.log(this.selection.salesOrderSn)
        const info = this.selection.salesOrderSn[0]
        // sap销售订单号
        this.form.sapOrderSn = ''
        // 销售订单号
        this.form.salesOrderId = info.id
        this.form.salesOrderSn = info.sn
        // 售达方
        this.form.soldToPartyId = info.soldToPartyId
        this.form.soldToPartyName = info.soldToPartyName
        // 送达方
        this.form.deliverySideId = info.deliverySideId || null
        this.form.deliverySideName = info.deliverySideName || null
        // 业务类型
        this.form.businessTypeId = info.businessTypeId || null
        this.form.businessTypeName = info.businessTypeName || null
        // 分销组织
        this.form.salesOrganizationId = info.salesOrganizationId
        this.form.channelOfDistributionId = info.channelOfDistributionId.toString()
        this.form.productTeamId = info.productTeamId.toString()
        console.log(info.salesOrganizationId, info.channelOfDistributionId, 1111111111111111111)
        this.getOptionOrganization(info.salesOrganizationId)
        this.getProductTeamOption(info.channelOfDistributionId)
        // 交货工厂
        this.form.factoryId = info.factoryId
        this.form.factoryName = info.factoryName
        // 中间公司
        this.form.middleCompanyId = info.middleCompanyId
        this.form.middleCompanyName = info.middleCompanyName
        this.form.mountingsList = []
      }
    },
    salesOrderSnClose() {
      this.showObj.salesOrderSn = false
    },
    // 配件
    addMountingsLine() {
      if (!this.form.salesOrderSn) {
        this.$message.warning('请先选择销售单号，再添加订单明细')
        return
      }
      this.showObj.mountings = true
      this.getMountings()
    },
    delectMountingsLine() {
      this.form.mountingsList = []
    },
    async getMountings(type = '') {
      if (type === 'refresh') {
        this.pagination.mountings.current = 1
      }
      this.loadingObj.mountings = true
      this.condition.mountings.productType = 1
      this.condition.mountings.salesOrderId = this.form.salesOrderId
      const reponse = await getDetailedDataPopup(this.condition.mountings, this.pagination.mountings)
      const { current, total, size, records } = reponse.data
      this.dialog.mountings = records
      this.pagination.mountings.total = total
      this.pagination.mountings.current = current
      this.pagination.mountings.size = size
      this.loadingObj.mountings = false
    },
    handleMountingsDelete(index) {
      this.form.mountingsList.splice(index, 1)
    },
    handleMountingsChange(val) {
      this.selection.mountings = val
    },
    mountingsConfirm() {
      const arr = JSON.parse(JSON.stringify(this.form.mountingsList))
      if (arr !== null && arr.length > 0) {
        this.form.mountingsList = mergeObjectArrayWithoutDuplicates(arr, this.selection.mountings, 'productCode', 'batch')
      } else {
        this.form.mountingsList = this.selection.mountings
        for (var i = 0; this.form.mountingsList.length > i; i++) {
          this.form.mountingsList[i].salesOrderDetailId = this.form.mountingsList[i].id
        }
      }
      for (const item of this.form.mountingsList) {
        console.log(isNaN(item.isPurchase))
        if (item.isPurchase !== true) {
          item.isPurchase = item?.isPurchase === 1
        }

        if (item.isPurchase && item?.crmPurchaseOrderModel) {
          console.log(item.crmPurchaseOrderModel)
          item.crmPurchaseOrderModel.purchaseOrderId = item.crmPurchaseOrderModel.id || null
          item.crmPurchaseOrderModel.salesReturnOrderId = this.form.id || null
          if (item.crmPurchaseOrderModel.id) {
            delete item.crmPurchaseOrderModel.id
          }
        }
        if (!item?.crmPurchaseReturnOrderModel) {
          item.crmPurchaseReturnOrderModel = item.crmPurchaseOrderModel
        }
      }

      if (this.taxRatio) {
        this.form.mountingsList.forEach((item, index) => {
          this.$set(this.form.mountingsList[index], 'taxRatio', this.taxRatio)
        })
      }
      this.showObj.mountings = false
    },
    mountingsClose() {
      this.showObj.mountings = false
    },
    // 配件-采购订单
    setPurchase(row, index) {
      this.showObj.purchase = true
      this.purchaseRow = row.crmPurchaseOrderModel ? row.crmPurchaseOrderModel : row.crmPurchaseReturnOrderModel
      this.purchaseIndex = index
      // this.purchaseRow.purchaseOrderId = this.purchaseRow.id
      // this.purchaseRow.salesReturnOrderId = this.form.id || null

      console.log(this.purchaseRow)
      // this.purchaseRow.purchasingOrganizationId = this.form.salesOrganizationId
      // this.purchaseRow.supplierId = this.purchaseRow.supplierId || this.supplierOptions[0].value
      // this.purchaseRow.purchaseBasicsId = this.purchaseRow.purchaseBasicsId || this.purchaseBasicsOptions[0].value
    },
    purchaseConfirm() {
      this.$refs['purchaseForm'].validate((valid, obj) => {
        if (valid) {
          // this.form.mountingsList[this.purchaseIndex].crmPurchaseOrderModel
          if (this.purchaseRow.id) {
            delete this.purchaseRow.id
          }
          console.log(this.purchaseRow)
          this.form.mountingsList[this.purchaseIndex].crmPurchaseReturnOrderModel = this.purchaseRow
          this.form.mountingsList[this.purchaseIndex].crmPurchaseOrderModel = this.purchaseRow
          console.log(this.form.mountingsList[this.purchaseIndex].crmPurchaseReturnOrderModel)
          this.purchaseClose()
        } else {
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          return false
        }
      })
    },
    purchaseClose() {
      this.purchaseIndex = null
      this.purchaseRow = {}
      this.showObj.purchase = false
    },
    // 废料
    addFlotsamLine() {
      if (!this.form.salesOrderSn) {
        this.$message.warning('请先选择销售单号，再添加订单明细')
        return
      }
      this.showObj.flotsam = true
      this.getFlotsam()
    },
    delectFlotsamLine() {
      this.form.flotsamList = []
    },
    async getFlotsam(type = '') {
      if (type === 'refresh') {
        this.pagination.flotsam.current = 1
      }
      this.loadingObj.flotsam = true
      this.condition.flotsam.productType = 2
      this.condition.flotsam.salesOrderId = this.form.salesOrderId
      const reponse = await getDetailedDataPopup(this.condition.flotsam, this.pagination.flotsam)
      const { current, total, size, records } = reponse.data
      this.dialog.flotsam = records
      this.pagination.flotsam.total = total
      this.pagination.flotsam.current = current
      this.pagination.flotsam.size = size
      this.loadingObj.flotsam = false
    },
    handleFlotsamDelete(index) {
      this.form.flotsamList.splice(index, 1)
    },
    handleFlotsamChange(val) {
      this.selection.flotsam = val
    },
    flotsamConfirm() {
      const arr = JSON.parse(JSON.stringify(this.form.flotsamList))
      if (arr !== null && arr.length > 0) {
        this.form.flotsamList = mergeObjectArrayWithoutDuplicates(arr, this.selection.flotsam, 'productCode')
      } else {
        this.form.flotsamList = this.selection.flotsam
      }

      if (this.taxRatio) {
        this.form.flotsamList.forEach((item, index) => {
          this.$set(this.form.flotsamList[index], 'taxRatio', this.taxRatio)
        })
      }
      console.log(this.form.flotsamList)
      this.showObj.flotsam = false
    },
    flotsamClose() {
      this.showObj.flotsam = false
    },
    // 审批人
    async getNodePersonDialog() {
      this.loadingObj.nodePerson = true
      const reponse = await getByGeneralManager(this.condition.nodePerson.nodePerson, this.form.roleId, this.pagination.nodePerson)
      const { current, total, size, records } = reponse.data
      this.dialog.nodePerson = records
      this.pagination.nodePerson.total = total
      this.pagination.nodePerson.current = current
      this.pagination.nodePerson.size = size
      this.loadingObj.nodePerson = false
    },

    // addNodePerson() {
    //   if (this.form.flowPathNodePersonModels === null) {
    //     this.form.flowPathNodePersonModels = []
    //   }
    //   this.form.flowPathNodePersonModels.push({})
    // },
    // deleteNodePerson(index) {
    //   this.form.flowPathNodePersonModels.splice(index, 1)
    // },
    async getFlowTempInfoList(e) {
      this.loading = true
      this.form.flowPathNodePersonModels = []
      const i = this.flowPathOptions.findIndex(v => v.id === e)
      this.form.roleId = this.flowPathOptions[i].roleId
      try {
        const res = await getFlowTempInfo(this.flowPathOptions[i].templateName)
        const nodeList = res.data.nodeList
        nodeList.shift()
        for (const item of nodeList) {
          let nodeVariate = ''
          const arr = []
          for (const v of item.userList) {
            if (v.variable) {
              v.username = v.username.substring(2, 13)
            }
            arr.push(v.username)
          }
          nodeVariate = arr.join()

          // 指定审核人赋值
          let nodePerson = null
          if (!item.userList[0].variable) {
            nodePerson = nodeVariate
          } else {
            nodePerson = null
          }
          this.form.flowPathNodePersonModels.push({
            nodePersonName: item.name,
            nodeVariate,
            nodePerson,
            nodePersonId: null,
            variable: item.userList[0].variable
          })
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    handleNodePersonSelectionChange(val) {
      this.selection.nodePerson = val
    },
    selectNodePerson(index) {
      this.nodePersonIndex = index
      this.showObj.nodePerson = true
      this.getNodePersonDialog()
    },

    nodePersonConfirm() {
      if (this.selection.nodePerson.length > 1) {
        this.$message.warning('只能选择一位审批人！')
      } else {
        this.showObj.nodePerson = false
        console.log(this.selection.nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePerson', this.selection.nodePerson[0].nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePersonId', this.selection.nodePerson[0].nodePersonId)
      }
    },
    nodePersonClose() {
      this.showObj.nodePerson = false
    },

    // 计算金额
    calculation() {
      if (this.form.mountingsList.length > 0) {
        this.form.mountingsList.forEach((item, index) => {
          this.$set(this.form.mountingsList[index], 'taxRatio', this.taxRatio)
          if (item.lordDutyPrice) {
            this.$set(this.form.mountingsList[index], 'taxlessPrice', this.amountExcludingTax(item.lordDutyPrice, this.taxRatio))
          }
        })
      }
      if (this.form.flotsamList.length > 0) {
        this.form.flotsamList.forEach((item, index) => {
          this.$set(this.form.flotsamList[index], 'taxRatio', this.taxRatio)
          if (item.lordDutyPrice) {
            this.$set(this.form.flotsamList[index], 'taxlessPrice', this.amountExcludingTax(item.lordDutyPrice, this.taxRatio))
          }
        })
      }
    },
    inclusiveAmount(qty, taxPrice) {
      const num = qty * taxPrice
      if (num.toString().split('.')[1] && num.toString().split('.')[1].length > 6) {
        return num.toFixed(6)
      } else {
        return num
      }
    },
    amountExcludingTax(lordDutyPrice, taxRatio) {
      const num = lordDutyPrice / (1 + taxRatio / 100)
      if (num.toString().split('.')[1] && num.toString().split('.')[1].length > 6) {
        return num.toFixed(6)
      } else {
        return num
      }
    },
    sumLordDutyPrice(item, index, type = '') {
      if (item.qty && item.taxPrice) {
        if (type === 'mountings') {
          this.$set(this.form.mountingsList[index], 'lordDutyPrice', this.inclusiveAmount(item.qty, item.taxPrice))
          this.sumTaxlessPrice(item, index, 'mountings')
        } else {
          this.$set(this.form.flotsamList[index], 'lordDutyPrice', this.inclusiveAmount(item.qty, item.taxPrice))
          this.sumTaxlessPrice(item, index)
        }
      }
    },
    sumTaxlessPrice(item, index, type = '') {
      if (item.lordDutyPrice && item.taxRatio) {
        if (type === 'mountings') {
          this.$set(this.form.mountingsList[index], 'taxlessPrice', this.amountExcludingTax(item.lordDutyPrice, item.taxRatio))
        } else {
          this.$set(this.form.flotsamList[index], 'taxlessPrice', this.amountExcludingTax(item.lordDutyPrice, item.taxRatio))
        }
      }
    },
    async getData() {
      if (!this.editId) return
      this.loading = true
      try {
        const response = await get(this.editId)
        const { data } = response
        this.form = data

        this.form.channelOfDistributionId = this.form.channelOfDistributionId.toString()
        this.form.productTeamId = this.form.productTeamId.toString()
        this.getOptionOrganization(this.form.salesOrganizationId)
        this.getProductTeamOption(this.form.channelOfDistributionId)
        // this.form.mountingsList = []
        // this.form.flotsamList = []
        this.$set(this.form, 'mountingsList', [])
        this.$set(this.form, 'flotsamList', [])
        this.form.flowPathTemplateId = this.form.flowPathTemplateId === 0 ? null : this.form.flowPathTemplateId
        if (this.form.salesReturnOrderLineVos && this.form.salesReturnOrderLineVos.length > 0) {
          for (const item of this.form.salesReturnOrderLineVos) {
            if (item.productType === 1) {
              item.isPurchase = item.isPurchase === 1
              console.log(item)
              this.form.mountingsList.push(item)
            } else {
              this.form.flotsamList.push(item)
            }
          }
        }
        if (this.form.mountingsList.length <= 0 && this.form.flotsamList.length > 0) {
          this.activePaneName = 'flotsam'
        }
        this.flowRejectTo(null, null)
        this.loading = false
        // this.$nextTick(() => {
        //   this.$refs.elTable.doLayout()
        // })
      } catch (error) {
        this.loading = false
      }
    },
    // 配件批量编码查询
    selectMountingsCodes() {
      this.mountingsCodes = true
    },
    mountingsCodesClose() {
      this.mountingsCodes = false
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$router.push({ query: {} })
      this.$emit('close')
    },
    async submitForm(formName, isClose = true, cb) {
      // ---- 需要手工填写此代码 -----
      this.$refs[formName].validate(async (valid, obj) => {
        if (valid) {
          // ---- 需要手工填写此代码 -----
          try {
            this.loading = true

            const formData = JSON.parse(JSON.stringify(this.form))
            // 没有送达方就赋值成售达方
            if (!formData.deliverySideId) {
              formData.deliverySideId = formData.soldToPartyId
              formData.deliverySideName = formData.soldToPartyName
            }
            formData.salesReturnOrderLineVos = formData.mountingsList.concat(formData.flotsamList)
            if (formData.salesReturnOrderLineVos.length <= 0) {
              this.$message.warning('订单明细不能为空')
              this.loading = false
              return
            }
            for (const item of formData.salesReturnOrderLineVos) {
              item.isPurchase = item.isPurchase ? 1 : 2
              if (item.isPurchase === 1) {
                if (!item.crmPurchaseReturnOrderModel.unitPrice || !item.crmPurchaseReturnOrderModel.qty) {
                  this.$message.warning('请补充完整的采购信息')
                  this.loading = false
                  return
                }
              }
            }

            delete formData.mountingsList
            delete formData.flotsamList
            const { message, data } = await saveOrUpdate(formData)
            this.$message({
              type: 'success',
              message: message
            })
            this.form.id = this.form.id || data
            this.editId = this.form.id || data
            await this.getData()
            this.loading = false
            if (cb) {
              await cb()
            }
            if (isClose) {
              this.handleClose()
            }
          } catch (error) {
            this.loading = false
          }
        } else {
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          return false
        }
      })
    },
    flowRefresh() {
      this.getData()
      this.handleClose()
    },
    flowLoad(e) {
      this.flowOptions = e
      this.$refs.flow.validatorForm.push(this.$refs.isProceeds)
    },
    flowRejectTo(isAssignee, nodeName) {
      if (isAssignee && nodeName === '开始') {
        this.isRejectTo = false
      } else {
        if (this.form.status > 1) {
          this.isRejectTo = true
        } else {
          this.isRejectTo = false
        }
      }
    },
    // 流程提交
    async onComplete() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      // if (!this.form.flowPathNodePersonModels) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择审批人'
      //   })
      //   return
      // }
      // if (this.form.flowPathNodePersonModels.length !== 2) {
      //   this.$message({
      //     type: 'warning',
      //     message: '只能选择两名审批人'
      //   })
      //   return
      // }
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        // await this.getData();
        // 在执行提交
        await this.$refs.flow.onComplete()
        this.handleClose()
      })
    },
    // 保存并提交
    async saveAndSubmit() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      // if (!this.form.flowPathNodePersonModels) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择审批人'
      //   })
      //   return
      // }
      // if (this.form.flowPathNodePersonModels.length !== 2) {
      //   this.$message({
      //     type: 'warning',
      //     message: '只能选择两名审批人'
      //   })
      //   return
      // }
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        await this.submit()
      })
    },
    async submit() {
      try {
        this.loading = true
        const response = await submit(this.form.id)
        this.form.flowId = response.data
        this.loading = false
        // this.handleClose()
        this.getData()
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.link {
  color: #606266;
  font-weight: lighter;
}
.link:hover {
  color: rgb(64, 158, 255);
  font-weight: lighter;
}
.upload {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
}
.upload >>> .el-upload-list__item:first-child {
  margin-top: 0;
}
.uploads {
  clear: both;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.el-upload {
  flex: 1;
}

.el-upload__tip {
  margin-top: 0;
  margin-left: 10px;
  flex: 1;
}
.el-col {
  min-height: 50px;
}
.blueBtn {
  font-size: 12px;
  color: rgb(64, 158, 255);
  margin: 0 2px;
  cursor: pointer;
}
</style>

